import type { BadgeVisibility, BadgeVisibilityOverrides } from '../types/gamificationBadges';

export const DEFAULT_BADGE_VISIBILITY: BadgeVisibility = {
  statuses: { 'coming-soon': true, 'needs-status': false },
  rewardsGrid: { 'coming-soon': true, 'needs-status': true },
};

// Override a badge for one benefit and surface, e.g.
// 'loss-insurance': { statuses: { 'coming-soon': false } }
export const BADGE_VISIBILITY_OVERRIDES: BadgeVisibilityOverrides = {
  'personal-slot-game': {
    statuses: { 'coming-soon': false },
  },
  'purchase-bonus': {
    statuses: { 'coming-soon': false },
  },
  'referral': {
    statuses: { 'coming-soon': false, 'needs-status': false },
    rewardsGrid: { 'coming-soon': false, 'needs-status': false },
  },
};
